import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useIntl } from 'react-intl';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type FragmentContext, type RecommendationConfig } from '../../../shared/types';
import { TrackingCategory, TrackingListName } from '../../enums';
import { bestsellerSliderMessages as messages } from '../../i18n';
import { Headlines } from '../Headlines';
import { ProductSlider } from '../ProductSlider';

const BestsellerSlider = ({
    lazyLoad,
    recommendationConfig,
}: {
    readonly lazyLoad: boolean;
    readonly recommendationConfig: RecommendationConfig;
}): JSX.Element | null => {
    const { initialState, options } = recommendationConfig;
    const intl = useIntl();
    const {
        tenantConfig: { bestsellerLink },
    } = useFragmentContext<FragmentContext>();
    const [virtualSlide, setVirtualSlide] = useState(false);

    useEffect(() => {
        flushSync(() => {
            setVirtualSlide(true);
        });
    }, []);

    const hasBothHeadlines = Boolean(options?.headline) && Boolean(options?.subHeadline);

    const products = initialState?.results || [];

    return products.length ? (
        <>
            <Headlines headline={options?.headline} subHeadline={options?.subHeadline} />
            <ProductSlider
                productItems={products}
                title={
                    recommendationConfig.options?.productSliderTitle ??
                    intl.formatMessage(messages.bestsellerProducts)
                }
                urlTitle={intl.formatMessage(messages.bestsellerShowMore)}
                url={bestsellerLink}
                trackingCategory={TrackingCategory.ProductList}
                trackingListName={TrackingListName.Bestseller}
                dataTestId="bestseller-slider"
                lazyLoad={lazyLoad}
                showTitle={!hasBothHeadlines}
                virtualSlide={virtualSlide}
            />
        </>
    ) : null;
};

export { BestsellerSlider };
